var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgClone = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    viewBox: "0 0 600 850",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M325,125H725a50.15,50.15,0,0,0-50-50H250a50.15,50.15,0,0,0-50,50V800a50.15,50.15,0,0,0,50,50V200A75.22,75.22,0,0,1,325,125Z",
    transform: "translate(-200 -75)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M750,150H325a50.15,50.15,0,0,0-50,50V875a50.15,50.15,0,0,0,50,50H750a50.15,50.15,0,0,0,50-50V200A50.15,50.15,0,0,0,750,150Zm0,575L400,200H750Z",
    transform: "translate(-200 -75)"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClone, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Clone.dcaec005.svg";
export { ForwardRef as ReactComponent };